var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoforissa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 841.47 841.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.91,589.06V248.01C502.64,112.97,394.38,3.78,259.71,0H0V168.38H252.58c46.38,0,83.98,37.6,83.98,83.98v336.7c0,29.42,5.03,57.68,14.29,83.92H0v168.38H841.47v-168.38h-254.71c-45.41-1.11-81.85-38.28-81.85-83.92Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 569.29,
    width: 272.18,
    height: 168.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoforissa);
export default __webpack_public_path__ + "static/media/logoforissa.c6189ccc9e9c52c70bee7ef40829fb44.svg";
export { ForwardRef as ReactComponent };